<template>
	<div class="Component">
		<div class="config-controls">
			<div class="move-block">
				<button class="move up" @click.prevent="$emit('moveOrder', index, -1)">&#8963;</button>

				<button class="move down" @click.prevent="$emit('moveOrder', index, 1)">&#8964;</button>
			</div>

			<span class="position">{{ index + 1 }}</span>
			<!--			<button class='copy'-->
			<!--							@click.prevent="$emit('copyConfig', config)"-->
			<!--			>-->
			<!--				<svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>-->
			<!--					<path fill-rule='evenodd' clip-rule='evenodd'-->
			<!--								d='M1.00016 10.9999L1.07791 10.9954C1.38396 10.9599 1.6268 10.7171 1.66234 10.411L1.66683 10.3333V1.66659H10.3335L10.4112 1.6621C10.7428 1.62359 11.0002 1.34181 11.0002 0.999919C11.0002 0.658028 10.7428 0.376247 10.4112 0.337737L10.3335 0.333252H1.00016L0.922415 0.337737C0.616361 0.373285 0.373529 0.616117 0.337981 0.922171L0.333496 0.999919V10.3333L0.337981 10.411C0.373529 10.7171 0.616361 10.9599 0.922415 10.9954L1.00016 10.9999ZM13.0001 13.6666L13.0779 13.6621C13.3839 13.6265 13.6268 13.3837 13.6623 13.0777L13.6668 12.9999V3.66658L13.6623 3.58883C13.6297 3.30828 13.423 3.08086 13.153 3.01752L13.0779 3.0044L13.0001 2.99991H3.66679L3.58904 3.0044C3.28299 3.03995 3.04016 3.28278 3.00461 3.58883L3.00012 3.66658V12.9999L3.00461 13.0777C3.03719 13.3582 3.24396 13.5856 3.51393 13.649L3.58904 13.6621L3.66679 13.6666H13.0001ZM4.3335 4.33325V12.3333H12.3335V4.33325H4.3335Z'-->
			<!--								fill='#6A5EA4' />-->
			<!--				</svg>-->

			<!--			</button>-->
			<button @click.prevent="$emit('deleteConfig')" class="remove">
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g clip-path="url(#clip0_3121_3096)">
						<path
							d="M10.2067 5.79688C9.99977 5.79688 9.83203 5.96462 9.83203 6.17158V13.2535C9.83203 13.4604 9.99977 13.6283 10.2067 13.6283C10.4137 13.6283 10.5814 13.4604 10.5814 13.2535V6.17158C10.5814 5.96462 10.4137 5.79688 10.2067 5.79688Z"
							fill="#6A5EA4" />
						<path
							d="M5.78535 5.79688C5.57838 5.79688 5.41064 5.96462 5.41064 6.17158V13.2535C5.41064 13.4604 5.57838 13.6283 5.78535 13.6283C5.99232 13.6283 6.16006 13.4604 6.16006 13.2535V6.17158C6.16006 5.96462 5.99232 5.79688 5.78535 5.79688Z"
							fill="#6A5EA4" />
						<path
							d="M2.56276 4.76335V13.9953C2.56276 14.541 2.76285 15.0534 3.11238 15.4211C3.4603 15.7898 3.94449 15.9991 4.45122 16H11.5408C12.0477 15.9991 12.5318 15.7898 12.8796 15.4211C13.2292 15.0534 13.4292 14.541 13.4292 13.9953V4.76335C14.1241 4.57893 14.5743 3.90768 14.4813 3.19471C14.3883 2.48189 13.781 1.94867 13.062 1.94852H11.1435V1.48014C11.1457 1.08626 10.99 0.708039 10.7112 0.42979C10.4323 0.151688 10.0535 -0.0031709 9.65964 4.92333e-05H6.33236C5.93848 -0.0031709 5.55968 0.151688 5.28084 0.42979C5.00201 0.708039 4.84627 1.08626 4.84847 1.48014V1.94852H2.93C2.21104 1.94867 1.60375 2.48189 1.51066 3.19471C1.41771 3.90768 1.86795 4.57893 2.56276 4.76335ZM11.5408 15.2506H4.45122C3.81056 15.2506 3.31217 14.7002 3.31217 13.9953V4.79629H12.6798V13.9953C12.6798 14.7002 12.1814 15.2506 11.5408 15.2506ZM5.59788 1.48014C5.59539 1.28503 5.67209 1.09724 5.81056 0.959502C5.94888 0.821768 6.13711 0.746095 6.33236 0.749461H9.65964C9.85489 0.746095 10.0431 0.821768 10.1814 0.959502C10.3199 1.09709 10.3966 1.28503 10.3941 1.48014V1.94852H5.59788V1.48014ZM2.93 2.69793H13.062C13.4345 2.69793 13.7365 2.99989 13.7365 3.3724C13.7365 3.74492 13.4345 4.04688 13.062 4.04688H2.93C2.55749 4.04688 2.25553 3.74492 2.25553 3.3724C2.25553 2.99989 2.55749 2.69793 2.93 2.69793Z"
							fill="#6A5EA4" />
						<path
							d="M7.99628 5.79688C7.78932 5.79688 7.62158 5.96462 7.62158 6.17158V13.2535C7.62158 13.4604 7.78932 13.6283 7.99628 13.6283C8.20325 13.6283 8.37099 13.4604 8.37099 13.2535V6.17158C8.37099 5.96462 8.20325 5.79688 7.99628 5.79688Z"
							fill="#6A5EA4" />
					</g>
					<defs>
						<clipPath id="clip0_3121_3096">
							<rect width="16" height="16" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</button>
		</div>

		<div class="config-row">
			<Addition v-if="config.type === 'addition'" :gameTypes="gameTypes" :onBlurRepeat="onBlurRepeat"
				:onInputRepeat="onInputRepeat" :config="config" />
			<AbacusRandom v-if="config.type === 'abacus_random'" :gameTypes="gameTypes" :config="config"
				:onBlurRepeat="onBlurRepeat" :onInputRepeat="onInputRepeat" />
			<Multiply v-if="config.type === 'multiply'" :gameTypes="gameTypes" ref="Multiply" :config="config"
				:onBlurRepeat="onBlurRepeat" :onInputRepeat="onInputRepeat" />
			<Divide v-if="config.type === 'divide'" :gameTypes="gameTypes" :config="config" :onBlurRepeat="onBlurRepeat"
				:onInputRepeat="onInputRepeat" />
			<Anzan v-if="config.type === 'anzan'" :gameTypes="gameTypes" :config="config" :onBlurRepeat="onBlurRepeat"
				:onInputRepeat="onInputRepeat" />
			<Negative v-if="config.type === 'negative'" :gameTypes="gameTypes" :config="config" :onBlurRepeat="onBlurRepeat"
				:onInputRepeat="onInputRepeat" />
			<Columns v-if="config.type === 'columns'" :gameTypes="gameTypes" :config="config" :onInputRepeat="onInputRepeat"
				:onBlurRepeat="onBlurRepeat" :value="config.repeat" />
			<div v-if="config.type === 'matific'" class="homework-row">
				<label>
					{{ 'Game type' | translate }}
					<select v-model="config.type" class="form-control">
						<option :value="type.value" v-for="(type, index) in gameTypes" :key="index">
							{{ type.label | translate }}
						</option>
					</select>
				</label>
			</div>
			<!--			<label-->
			<!--				v-if="config.type !== 'columns' && config.type !== 'matific'"-->
			<!--				class='col-2'-->
			<!--			>-->
			<!--				{{ 'Time' | translate }}-->
			<!--				<p>-->
			<!--					{{ totalTime }}-->
			<!--					{{ 'Second' | translate }}-->
			<!--				</p>-->
			<!--			</label>-->
		</div>
	</div>
</template>

<script>
import Addition from './Addition'
import Divide from './Divide'
import AbacusRandom from './AbacusRandom'
import Multiply from './Multiply'
import Anzan from './Anzan'
import Negative from './Negative'
import Columns from './Columns'

import {
	DEFAULT_ADDITION_OPTIONS,
	DEFAULT_COLUMNS_OPTIONS,
	DEFAULT_ABACUS_RANDOM_OPTIONS,
	DEFAULT_MULTIPLY_25X25_OPTIONS,
	DEFAULT_MULTIPLY_OPTIONS,
	DEFAULT_MULTIPLY_BASE_OPTIONS,
	DEFAULT_MULTIPLY_QUAD_OPTIONS,
	DEFAULT_DIVIDE_OPTIONS,
	DEFAULT_NEGATIVE_OPTIONS
} from '@/components/Dashboard/Homework/Create'

export default {
	name: 'game-config',
	data: () => ({
		gameTypes: [
			{ value: 'addition', label: 'Speedy numbers' },
			{ value: 'columns', label: 'games.columns.name' },
			{ value: 'abacus_random', label: 'Abacus is random' },
			{ value: 'multiply', label: 'Multiplication' },
			{ value: 'divide', label: 'Division' },
			{ value: 'negative', label: 'games.negativeNumbers' },
			// { value: 'matific', label: 'Matific' },
			// { value: 'anzan', label: 'Anzan' },
		],
	}),
	watch: {
		computedConfig: {
			handler: function (value, prev) {

				const oldValue = JSON.parse(prev)
				const newValue = JSON.parse(value)

				if (oldValue.type !== newValue.type && oldValue.initialOrder === newValue.initialOrder) {
					this.config.options = { ...this.getDefaults(newValue.type) }
				}
			},
			deep: true
		}
	},

	computed: {
		computedConfig() {
			return JSON.stringify(this.config);
		},
		totalTime() {
			const repeat = +this.config.repeat || 0
			let speed = +this.config.options.speed || 0
			let length = +this.config.options.length || 0

			if (this.config.type === 'divide' || this.config.type === 'multiply') {
				speed = 1
				length = 1
			}

			return (speed * repeat * length).toFixed(0)
		},
	},
	methods: {
		getDefaults(type) {
			let defaults = {
				addition: DEFAULT_ADDITION_OPTIONS,
				columns: DEFAULT_COLUMNS_OPTIONS,
				abacus_random: DEFAULT_ABACUS_RANDOM_OPTIONS,
				multiply: DEFAULT_MULTIPLY_OPTIONS,
				divide: DEFAULT_DIVIDE_OPTIONS,
				negative: DEFAULT_NEGATIVE_OPTIONS,
			}

			return JSON.parse(JSON.stringify(defaults[type]))
		},

		validateMultiply() {
			this.$refs.Multiply.validate()
		},
		onInputRepeat({ target }) {
			let {
				value,
				validity: { valid },
			} = target
			value = value && !valid ? this.config.repeat : value
			this.config.repeat = value
			target.value = value
		},
		onBlurRepeat() {
			if (!this.config.repeat || Number(this.config.repeat < 1)) {
				this.config.repeat = 1
			}
		},
	},
	props: ['config', 'length', 'hasMatific', 'index', 'copyConfig', 'moveOrder'],
	components: {
		Anzan,
		Addition,
		Divide,
		Multiply,
		Negative,
		AbacusRandom,
		Columns,
	},
	created() {
		if (this.config.id) {
			this.config.id = undefined
		}

		if (this.config?.isNew) {
			this.config.options = { ...this.getDefaults('addition') }
			this.config.isNew = false
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import url(https://unpkg.com/vue-multiselect@2.1.0/dist/vue-multiselect.min.css);

.Component {
	margin-top: 20px;
	flex-direction: column;
	display: flex;
	width: 100%;
}

.type-game {
	margin-right: 24px;
	display: inline-flex;
	flex-direction: column;
}

.config-controls {
	border-radius: 16px;
	position: relative;
	margin-bottom: -20px;
	margin-left: 24px;
	padding: 8px;
	display: inline-flex;
	width: fit-content;
	align-items: center;
	background-color: var(--violet-silver-color);

	button.remove {
		margin-left: 8px;
		background-color: transparent;
		border-radius: 8px;
		width: 32px;
		height: 32px;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid var(--violet-color);
	}

	button.move {
		margin-right: 8px;
		background-color: transparent;

		color: var(--violet-color);

		width: 30px;
		height: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid var(--violet-color);

		&.up {
			padding-top: 14px;
			border-radius: 8px 8px 0 0;
		}

		&.down {
			padding-bottom: 6px;
			border-radius: 0 0 8px 8px;
		}
	}



	.position {
		background: #ffffff;
		border-radius: 8px;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 20px;
		color: var(--violet-color) !important;
	}
}

.config-row {
	width: 100%;
	padding: 32px;
	margin-bottom: 20px;
	background: #ffffff;
	box-shadow: 0px 2px 12px #e6e9f3;
	border-radius: 16px;
	display: flex;
}

#dashboard .add-config {
	color: #e5a33f;
	display: inline-block;
	margin-top: 15px;
	margin-bottom: 15px;
	font-size: 40px;
}

#dashboard .multiselect .multiselect__tag {
	color: #ffffff;
}
</style>
